import type { FilterItem } from '@/app/components/rates-and-prices-listing/filters';
import type { BPID } from '@energy-retailer/schema';

enum ActionTypes {
  SetItems = 'SET_ITEMS',
  SetOptions = 'SET_OPTIONS',
  SetFilters = 'SET_FILTERS',
  ResetFilters = 'RESET_FILTERS',
}

export type Actions =
  | {
      type: ActionTypes.SetItems;
      payload: BPID[];
    }
  | {
      type: ActionTypes.SetOptions;
      payload: FilterItem[];
    }
  | {
      type: ActionTypes.SetFilters;
      payload: FilterItem;
    }
  | {
      type: ActionTypes.ResetFilters;
    };

export default ActionTypes;
